import { useEffect, useState } from "react";
import { AccessControlAPI, AccessSystemsAPI } from "../../api/accessControl";

export default function AccessControlActionsPage() {
  const [systems, setSystems] = useState([]);
  const [systemId, setSystemId] = useState("");
  const [schoolId, setSchoolId] = useState("");
  const [action, setAction] = useState("GetAllUsers");

  const [email, setEmail] = useState("");
  const [tokenNumber, setTokenNumber] = useState("");
  const [firstName, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [accessLevel, setAccessLevel] = useState("");

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    loadSystems();
  }, []);

  async function loadSystems() {
    try {
      const data = await AccessSystemsAPI.list();
      const enabled = Array.isArray(data) ? data.filter((s) => s.enabled) : [];
      setSystems(enabled);
    } catch (err) {
      console.error(err);
      setError("Failed to load systems");
    }
  }

  function handleSystemChange(id) {
    const selected = systems.find((s) => String(s.id) === id);
    setSystemId(id);
    setSchoolId(selected ? selected.school_id : "");
  }

  async function run() {
    setLoading(true);
    setError("");
    setResult(null);

    try {
      const payload = buildPayload();

      const job = await AccessControlAPI.runAction({
        systemId: Number(systemId),
        schoolId: Number(schoolId),
        action,
        payload,
      });

      setResult(job);
    } catch (err) {
      console.error(err);
      setError("Failed to run action");
    } finally {
      setLoading(false);
    }
  }

  function buildPayload() {
    switch (action) {
      case "GetUserTokens":
      case "UpdateUser":
        return { EmailAddress: email };

      case "AddToken":
      case "RemoveToken":
        return {
          EmailAddress: email,
          TokenNumber: tokenNumber,
        };

      case "AddUser":
        return {
          EmailAddress: email,
          FirstName: firstName,
          Surname: surname,
          AccessLevel: accessLevel,
        };

      default:
        return {};
    }
  }

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-semibold">Access Control Actions</h1>

      {error && (
        <div className="text-red-600">{error}</div>
      )}

      <div className="rounded border bg-white p-4 space-y-4 max-w-xl">
        <select
          value={systemId}
          onChange={(e) => handleSystemChange(e.target.value)}
          className="w-full border p-2"
        >
          <option value="">Select system</option>
          {systems.map((s) => (
            <option key={s.id} value={s.id}>
              {s.school_name} — {s.system_name}
            </option>
          ))}
        </select>

        <select
          value={action}
          onChange={(e) => setAction(e.target.value)}
          className="w-full border p-2"
        >
          <option>GetAllUsers</option>
          <option>GetDoorStatus</option>
          <option>GetUserTokens</option>
          <option>UpdateUser</option>
          <option>AddToken</option>
          <option>RemoveToken</option>
          <option>AddUser</option>
        </select>

        {(action !== "GetAllUsers" && action !== "GetDoorStatus") && (
          <input
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border p-2"
          />
        )}

        {(action === "AddToken" || action === "RemoveToken") && (
          <input
            placeholder="Token Number"
            value={tokenNumber}
            onChange={(e) => setTokenNumber(e.target.value)}
            className="w-full border p-2"
          />
        )}

        {action === "AddUser" && (
          <>
            <input
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="w-full border p-2"
            />
            <input
              placeholder="Surname"
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
              className="w-full border p-2"
            />
            <input
              placeholder="Access Level"
              value={accessLevel}
              onChange={(e) => setAccessLevel(e.target.value)}
              className="w-full border p-2"
            />
          </>
        )}

        <button
          onClick={run}
          disabled={loading || !systemId}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          {loading ? "Running..." : "Run Action"}
        </button>
      </div>

      {result && (
        <pre className="bg-gray-100 p-4 text-xs overflow-auto">
          {JSON.stringify(result, null, 2)}
        </pre>
      )}
    </div>
  );
}
